import { apiJson, replaceUserEndpoint } from './userEndpoint';

const summaryInflight = new Map();

export function fetchChallengeWireSummary({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	const cacheKey = `${userId}:${url}`;

	if (summaryInflight.has(cacheKey)) {
		return summaryInflight.get(cacheKey);
	}

	const request = apiJson(url, { csrfToken })
		.then((r) => r.data)
		.finally(() => {
			summaryInflight.delete(cacheKey);
		});

	summaryInflight.set(cacheKey, request);
	return request;
}

export function fetchFriendships({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}

export function createFriendship({ userId, endpoint, csrfToken, email }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, {
		method: 'POST',
		csrfToken,
		body: { friendship: { email } }
	});
}

export function acceptFriendship({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'PATCH', csrfToken });
}

export function declineFriendship({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'PATCH', csrfToken });
}

export function deleteFriendship({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'DELETE', csrfToken });
}

export function fetchHouseholdLinks({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}

export function createHouseholdLink({ userId, endpoint, csrfToken, email }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, {
		method: 'POST',
		csrfToken,
		body: { household_link: { email } }
	});
}

export function acceptHouseholdLink({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'PATCH', csrfToken });
}

export function declineHouseholdLink({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'PATCH', csrfToken });
}

export function deleteHouseholdLink({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { method: 'DELETE', csrfToken });
}

export function fetchLinkedHouseholdProfiles({ userId, endpoint, csrfToken, id }) {
	const url = replaceUserEndpoint(endpoint, { userId, id });
	return apiJson(url, { csrfToken }).then((r) => r.data || []);
}

export function fetchFriendChallenges({ userId, endpoint, csrfToken, role }) {
	const base = replaceUserEndpoint(endpoint, { userId });
	const url = role ? `${base}?role=${encodeURIComponent(role)}` : base;
	return apiJson(url, { csrfToken }).then((r) => r.data || []);
}

export function createFriendChallenge({ userId, endpoint, csrfToken, payload }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, {
		method: 'POST',
		csrfToken,
		body: { fitness_challenge: payload }
	}).then((r) => r.data);
}

export function patchFriendChallenge({ endpoint, csrfToken, body }) {
	return apiJson(endpoint, { method: 'PATCH', csrfToken, body });
}

export function fetchHouseholdChallenges({ userId, endpoint, csrfToken, status, fitnessProfileId }) {
	const base = replaceUserEndpoint(endpoint, { userId });
	const params = new URLSearchParams();
	if (status) params.set('status', status);
	if (fitnessProfileId) params.set('fitness_profile_id', String(fitnessProfileId));
	const query = params.toString();
	const url = query ? `${base}?${query}` : base;
	return apiJson(url, { csrfToken }).then((r) => r.data || []);
}

export function createHouseholdChallenge({ userId, endpoint, csrfToken, payload }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { method: 'POST', csrfToken, body: payload }).then((r) => r.data);
}

export function patchHouseholdChallenge({ endpoint, csrfToken, body }) {
	return apiJson(endpoint, { method: 'PATCH', csrfToken, body });
}

export function fetchProfileSuggestions({ userId, fitnessProfileId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId, fitnessProfileId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}

export function fetchFriendSuggestions({ userId, friendUserId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId, friendUserId });
	return apiJson(url, { csrfToken }).then((r) => r.data);
}
